import React from "react";

function Checkout_header(){

    return(
        <div className="checkout-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>تکمیل سفارش</h1>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Checkout_header;